<div class="lg-slideout-holder__header" lgArrowNavigation [horizontalNavigation]="true">
    @if (!!_slideoutApi) {
        @if (headerTemplate != null) {
            <div class="lg-slideout-holder__header-custom">
                <ng-template [ngTemplateOutlet]="headerTemplate"></ng-template>
            </div>
        } @else {
            @if (!activeStandalone) {
                <div class="lg-slideout-holder__header-buttons">
                    @for (panel of _availablePanels; track panel.panelVariant) {
                        <ng-container
                            *ngTemplateOutlet="
                                !panel.isActive || tabButtonTemplate == null
                                    ? DefaultButtonTemplate
                                    : tabButtonTemplate
                            "
                        >
                        </ng-container>
                        <ng-template #DefaultButtonTemplate>
                            <button
                                class="button lg-slideout-holder__header-tab-button"
                                [ngClass]="panel.isActive ? 'button--primary' : 'button--secondary'"
                                (click)="_changePanel(panel)"
                            >
                                {{ panel.nameLc | lgTranslate }}
                            </button>
                        </ng-template>
                    }
                </div>
            } @else if (activePanel != null) {
                <div class="lg-slideout-holder__header-standalone-title">
                    @if (activePanel.icon) {
                        <lg-icon [icon]="activePanel.icon" />
                    }
                    <span>{{ activePanel.nameLc | lgTranslate }}</span>
                </div>
            }
        }
    }

    <div
        class="lg-slideout-holder__header-icons"
        [ngClass]="!_slideoutApi ? 'lg-slideout-holder__header-icons--without-tabs' : ''"
    >
        @if (!!_slideoutApi) {
            @if (iconsTemplate != null && headerTemplate == null) {
                <ng-template [ngTemplateOutlet]="iconsTemplate"></ng-template>
            }
            @if (!hidePin || pinned) {
                <lg-icon
                    [tabIndex]="0"
                    class="lg-icon-menu__default lg-icon-menu"
                    [icon]="pinned ? 'icon-pin_down' : 'icon-pin'"
                    (click)="_togglePin()"
                    (keydown.enter)="_togglePin()"
                />
            }
            <lg-icon
                class="lg-icon-menu__default lg-icon-menu"
                [tabIndex]="0"
                icon="icon-close"
                (click)="_hide()"
                (keydown.enter)="_hide()"
            />
        } @else {
            <ng-content></ng-content>
        }
    </div>
</div>
